module.exports = __webpack_public_path__ + "img/good_casper_black.ead35f34.png";